var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page xieyi_page"},[_c('div',{staticClass:"block30"}),_c('div',{staticClass:"w1200 xieyi_page_box"},[_c('div',{staticClass:"conbox",domProps:{"innerHTML":_vm._s(_vm.actObj.contents)}})]),_c('div',{staticClass:"block30"})])
}
var staticRenderFns = []

export { render, staticRenderFns }